import React, { createContext, useContext, useState } from "react";

const SessionContext = createContext(null);

export const SessionProvider = ({ children }) => {
  const [sessionReady, setSessionReady] = useState(false);
  // Set only when POST /login answers 403, i.e. the backend refuses this user
  // outright. Routes behind LoginForbiddenGate stop rendering once it is true.
  const [loginForbidden, setLoginForbidden] = useState(false);

  return (
    <SessionContext.Provider
      value={{
        sessionReady,
        setSessionReady,
        loginForbidden,
        setLoginForbidden,
      }}>
      {children}
    </SessionContext.Provider>
  );
};

export const useSession = () => {
  const context = useContext(SessionContext);
  if (context === null) {
    throw new Error("useSession must be used within a SessionProvider");
  }
  return context;
};
